// Tab "Incolla codici" dei filtri avanzati articoli MODA. La pulizia replica
// parseCodiciIncollati del backend (vs-translations-api,
// src/services/moda/modaArticoliFilters.ts): l'anteprima deve mostrare
// esattamente i codici che il server cercherà.
export const CODICI_INCOLLATI_TIPI = [
  { value: "codVS", label: "Codice VS", plurale: "codici VS" },
  { value: "codProd", label: "Codice produttore", plurale: "codici produttore" },
];

export const CODICI_INCOLLATI_DEFAULT_TIPO = "codVS";

// Il filtro viaggia anche nella query string delle GET (lista, totali,
// statistiche): oltre questa lunghezza codificata l'URL rischia di superare il
// limite di 16 KB degli header di Node insieme al token. Il backend accetta al
// massimo 2000 codici.
export const CODICI_INCOLLATI_MAX_PARAM_LENGTH = 8000;
export const CODICI_INCOLLATI_MAX = 2000;

const SEPARATORI = /[\r\n\t,;]+/;
const BORDI =
  /^[\s '"`‘’“”«»()[\]]+|[\s '"`‘’“”«»()[\]]+$/g;

export const parseCodiciIncollati = (input) => {
  const parts = Array.isArray(input)
    ? input.flatMap((item) => String(item ?? "").split(SEPARATORI))
    : String(input ?? "").split(SEPARATORI);
  const seen = new Set();
  const codes = [];
  let duplicati = 0;
  parts.forEach((part) => {
    const code = part.replace(BORDI, "");
    if (!code) return;
    const key = code.toUpperCase();
    if (seen.has(key)) {
      duplicati += 1;
      return;
    }
    seen.add(key);
    codes.push(code);
  });
  return { codes, duplicati };
};

export const getCodiciIncollatiTipo = (value) =>
  CODICI_INCOLLATI_TIPI.find((tipo) => tipo.value === value) ??
  CODICI_INCOLLATI_TIPI[0];

export const getCodiciIncollatiParamLength = (codes) =>
  encodeURIComponent(codes.join(",")).length;

export const isCodiciIncollatiTroppoLungo = (codes) =>
  codes.length > CODICI_INCOLLATI_MAX ||
  getCodiciIncollatiParamLength(codes) > CODICI_INCOLLATI_MAX_PARAM_LENGTH;

// Testo del riepilogo filtri: mai l'elenco, solo quanti e di che tipo.
export const describeCodiciIncollati = (codes, tipoValue) => {
  const tipo = getCodiciIncollatiTipo(tipoValue);
  return codes.length === 1
    ? `1 ${tipo.label.toLowerCase()}`
    : `${codes.length} ${tipo.plurale}`;
};

// Prima dell'invio il testo della textarea diventa l'elenco ripulito; senza
// codici spariscono entrambe le chiavi, così il tipo da solo non è un filtro.
export const normalizeCodiciIncollatiFilters = (filters) => {
  const next = { ...filters };
  const { codes } = parseCodiciIncollati(next.codiciIncollati);
  if (!codes.length) {
    delete next.codiciIncollati;
    delete next.codiciIncollatiTipo;
    return next;
  }
  next.codiciIncollati = codes;
  next.codiciIncollatiTipo =
    next.codiciIncollatiTipo || CODICI_INCOLLATI_DEFAULT_TIPO;
  return next;
};
